import styles from './Input.module.scss'

import { c } from '@/utils'

interface InputProps {
  value: string
  onInput?: (text: string) => void
  placeholder?: string
  type: string
  isDisabled?: boolean
  className?: string
  readOnly?: boolean
  id?: string
  max?: string
  min?: string
  maxLength?: number
  ariaLabel?: string
  'aria-describedby'?: React.AriaAttributes['aria-describedby']
  'aria-invalid'?: React.AriaAttributes['aria-invalid']
  inputMode?: React.InputHTMLAttributes<HTMLInputElement>['inputMode']
}

const Input = (props: InputProps) => {
  const classNames = c(styles.input, props.className)

  if (props.type === 'textarea') {
    return (
      <textarea
        aria-label={props.ariaLabel}
        aria-describedby={props['aria-describedby']}
        aria-invalid={props['aria-invalid']}
        id={props.id}
        className={classNames}
        disabled={props.isDisabled}
        value={props.value}
        onInput={(e) => props.onInput?.(e.currentTarget.value)}
        placeholder={props.placeholder}
        rows={4}
      />
    )
  }

  return (
    <input
      aria-label={props.ariaLabel}
      aria-describedby={props['aria-describedby']}
      aria-invalid={props['aria-invalid']}
      id={props.id}
      type={props.type}
      className={classNames}
      disabled={props.isDisabled}
      value={props.value}
      onInput={(e) => props.onInput?.(e.currentTarget.value)}
      placeholder={props.placeholder}
      readOnly={props.readOnly}
      max={props.max}
      min={props.min}
      maxLength={props.maxLength}
      inputMode={props.inputMode}
    />
  )
}

export default Input
